import * as R from 'ramda';

const {CampaignAudienceLocation} = window.sn.enums;

const countryCodesEurope = [
    'al',
    'ad',
    'at',
    'by',
    'be',
    'ba',
    'bg',
    'hr',
    'cy',
    'cz',
    'dk',
    'ee',
    'fo',
    'fi',
    'fr',
    'de',
    'gi',
    'gr',
    'hu',
    'is',
    'ie',
    'it',
    'lv',
    'li',
    'lt',
    'lu',
    'mk',
    'mt',
    'md',
    'mc',
    'nl',
    'no',
    'pl',
    'pt',
    'ro',
    'ru',
    'sm',
    'rs',
    'sk',
    'si',
    'es',
    'se',
    'ch',
    'ua',
    'gb',
    'va',
    'rs',
    'im',
    'me'
];

export function getCountryLocationArray(country) {
    const {US, US_CANADA, US_EUROPE, EUROPE, WORLDWIDE} = CampaignAudienceLocation;

    // united states
    if (country === 'us') {
        return [US, US_CANADA, US_EUROPE, WORLDWIDE];
    }

    // canada
    if (country === 'ca') {
        return [US_CANADA, WORLDWIDE];
    }

    // europe
    if (R.contains(country, countryCodesEurope)) {
        return [US_EUROPE, EUROPE, WORLDWIDE];
    }

    return [WORLDWIDE];
}



// WEBPACK FOOTER //
// ./common/country_helper.js